export default "__VITE_ASSET__79ffa859__"